import React from 'react'
import Modal from './Modal'
import '../App.css';
import { userContext } from '../hooks/contextAPI'
import img from '../images/search--v2.png'
import ReactPlayer from 'react-player'
import youtubeApi from '../api/youtubeApi'


export const FoodSearch = React.forwardRef((props, ref) => {
    const open = React.useContext(userContext)

    return (

        <>
            <div className="jackpot-flex" id="jackpot" ref={ref}>

                <h1> Food Jackpot</h1>
                <p className="jackpot-text">  Randomly generate any food by entering the keyword. <br /> We will choose the best menu for you!</p>
                <Search />
                <div className="content-flex">

                    {!open.show ?
                        <button className="page" onClick={() => open.setShow(!open.show)} disabled={open.disabled}>
                            <div className="container">
                                <div className="shadow-wrapper">
                                    <div className="shadow">
                                        <div>&nbsp;</div>
                                    </div>
                                </div>
                                <div className="box-wrapper">
                                    <div className="box-faces">
                                        <div className="box-face box-face--is-front">
                                            <p>
                                                <i className="icon-rocket icon-4x"></i>
                                            </p>
                                        </div>
                                        <div className="box-face box-face--is-back">
                                            <p>
                                                <i className="icon-rocket icon-4x"></i>
                                            </p>
                                        </div>
                                        <div className="box-face box-face--is-top">&nbsp;</div>
                                        <div className="box-face box-face--is-bottom">&nbsp;</div>
                                        <div className="box-face box-face--is-left">
                                            <p>
                                                <i className="icon-rocket icon-4x"></i>
                                            </p>
                                        </div>
                                        <div className="box-face box-face--is-right">
                                            <p>
                                                <i className="icon-rocket icon-4x"></i>
                                            </p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </button> : null}

                </div>

            </div>


        </>

    )
})





let keyword = null
let outputArray = []
let ingrArray = []
let recipeArray = []
function Search() {

    const ID = "9fa7d6d9"
    const API_KEY = "677e0ebe37f89cc112cd93da89bc4874"

    const [query, setQuery] = React.useState('')
    const [menuSelected, setMenu] = React.useState('')
    const [image, setImage] = React.useState('')
    const inputRef = React.useRef()
    const [drop, setDrop] = React.useState(false)
    const open = React.useContext(userContext)
    const [state, dispatch] = React.useReducer(reducer, keyword)
    const [diet, setDiet] = React.useState(null)
    const [meal, setMeal] = React.useState(null)
    const [cuisine, setCuisine] = React.useState(null)
    const [health, setHealth] = React.useState(null)
    const [dish, setDish] = React.useState(null)

    const [diets, setDiets] = React.useState(null)
    const [meals, setMeals] = React.useState(null)
    const [cuisines, setCuisines] = React.useState(null)
    const [healths, setHealths] = React.useState(null)
    const [dishs, setDishs] = React.useState(null)

    const [blog, setBlog] = React.useState('')
    const [ingr, setIngr] = React.useState([])
    const [opens, setOpens] = React.useState(false)
    const [url, setUrl] = React.useState(null)


    const getRecipeData = async (searchQuery) => {
        const response = await fetch(
            `https://api.edamam.com/search?q=${searchQuery}&app_id=${ID}&app_key=${API_KEY}&from=0&to=100&${healths}${health}&${diets}${diet}&${meals}${meal}&${cuisines}${cuisine}&${dishs}${dish}`
        )
        const data = await response.json()
        getRandomMenu(data.hits)
    }

    const getRandomMenu = (menu) => {


        outputArray.push(menu)

        return (
            <div>
                <li>
                    {menu.length !== 0 ? outputArray.map((menus) => {
                        const num = Math.floor(Math.random() * outputArray.length)

                        setMenu(menus[num].recipe.label)
                        setImage(menus[num].recipe.image)
                        onSearch(menus[num].recipe.label)
                        setBlog(menus[num].recipe.url)
                        setIngr(menus[num].recipe.ingredientLines)
                        
                    }) : outputArray.map((menus) => {
                        const num = Math.floor(Math.random() * 10)

                        setMenu('Invalid Input')
                        setImage('Unable to fetch image')
                        onSearch(null)
                        setBlog('')
                        setIngr([])


                    })}
                </li>
            </div>
        )
    }

    const handleChange = (e) => {

        setQuery(e.target.value)


    }

    const handleClick = () => {

        if (query !== "") {

            setQuery('')
            GetCustomData(query, null)
            open.setClick(!open.click)
            open.setBtn(!open.disabled)
            open.setBtn(!open.disabled)
            setTimeout(() => {
                open.setBtn(open.disabled)
            }, 5000)




        }
         if (dish !== null) {

            getRecipeData(query, null)
            setDishs('dishType=')
            open.setClick(!open.click)
            open.setBtn(!open.disabled)
            open.setBtn(!open.disabled)
            setTimeout(() => {
                open.setBtn(open.disabled)
            }, 5000)
        } 
         if(health !== null){
            setDishs('health=')
            getRecipeData(query, null)
            setDishs('dishType=')
            open.setClick(!open.click)
            open.setBtn(!open.disabled)
            open.setBtn(!open.disabled)
            setTimeout(() => {
                open.setBtn(open.disabled)
            }, 5000)
        } 
         if(diet !== null){
            setDishs('diet=')
            getRecipeData(query, null)
            setDishs('dishType=')
            open.setClick(!open.click)
            open.setBtn(!open.disabled)
            open.setBtn(!open.disabled)
            setTimeout(() => {
                open.setBtn(open.disabled)
            }, 5000)
        }
         if(cuisine !== null){
            setDishs('cuisineType=')
            getRecipeData(query, null)
            setDishs('dishType=')
            open.setClick(!open.click)
            open.setBtn(!open.disabled)
            open.setBtn(!open.disabled)
            setTimeout(() => {
                open.setBtn(open.disabled)
            }, 5000)
        }
        if(meal !== null){
            setDishs('mealType=')
            getRecipeData(query, null)
            setDishs('dishType=')
            open.setClick(!open.click)
            open.setBtn(!open.disabled)
            open.setBtn(!open.disabled)
            setTimeout(() => {
                open.setBtn(open.disabled)
            }, 5000)
        }
        
        else {
            inputRef.current.focus()
        }
    }

    const handleClick2 = () => {
        open.setOpen(!open.open)
    }

    const handleClick3 = () => {
        open.setCustom(!open.custom)

    }


    function reducer(state, action) {

        setTimeout(() => {
            open.setBtn(open.disabled)
        }, 2000)

        switch (action.type) {
            case 'healthy':
                state = "healthy"
                open.setClick(!open.click)
                GetCustomData(state)
                open.setBtn(!open.disabled)
                break

            case 'family':
                state = "family"
                open.setClick(!open.click)
                GetCustomData(state)
                open.setBtn(!open.disabled)
                break;
            case 'low sodium':
                state = "low sodium"
                open.setClick(!open.click)
                GetCustomData(state)
                open.setBtn(!open.disabled)


                break;
            case 'low calorie':
                state = "low calorie"
                open.setClick(!open.click)
                GetCustomData(state)
                open.setBtn(!open.disabled)


                break;

            case 'balanced':
                state = "balanced"
                open.setClick(!open.click)
                GetCustomData(state)
                open.setBtn(!open.disabled)
                break;

            case 'high protein':
                state = "high protein"
                open.setClick(!open.click)
                GetCustomData(state)
                open.setBtn(!open.disabled)
                break;
                
            case 'low carb':
                state = "low carbs"
                open.setClick(!open.click)
                GetCustomData(state)
                open.setBtn(!open.disabled)
                break;
            case 'low fat':
                state = "low fat"
                open.setClick(!open.click)
                GetCustomData(state)
                open.setBtn(!open.disabled)
                break;
            default:
                return state
        }
    }


    async function GetCustomData(searchQuery) {
        const ID = "9fa7d6d9"
        const API_KEY = "677e0ebe37f89cc112cd93da89bc4874"

        const response = await fetch(
            `https://api.edamam.com/search?q=${searchQuery}&app_id=${ID}&app_key=${API_KEY}&from=0&to=100&calories=591-722`
        )
        const data = await response.json()

        outputArray.push(data.hits)
        return (
            <div>
                <li>

                    {data.hits.length !== 0 ? outputArray.map((menus) => {
                        const num = Math.floor(Math.random() * 10)

                        setMenu(menus[num].recipe.label)
                        setImage(menus[num].recipe.image)
                        onSearch(menus[num].recipe.label)
                        setBlog(menus[num].recipe.url)
                        setIngr(menus[num].recipe.ingredientLines)
                    }) : outputArray.map((menus) => {


                        setMenu('Invalid Input')
                        setImage('Unable to fetch image')
                        onSearch(null)
                        setBlog('')
                        setIngr(null)


                    })}
                </li>
            </div>
        )


    }

    const onSearch = async (recipe) => {
        if (recipe !== null) {
            const response = await youtubeApi.get("/search", {
                params: {
                    q: recipe


                }
            })
            setUrl(response.data.items[0].id.videoId)
            open.setVideo(url)
        } else {
            open.setVideo(null)
        }

    }

    const handleImage = () => {
        open.setShow(!open.show)
        setBlog('')
        setIngr([])
        open.setVideo(null)
        setUrl(null)
        setMenu('')
        setImage('')
    }


    return (

        <div className="search">
            <div className="search-2">

                <input ref={inputRef} type="text" placeholder="Search Ingredient..." onChange={handleChange} value={query} className="inputfield" />
                <button onClick={handleClick} className="search-btn"> <img src={img} alt="searchedFood" /> </button>
            </div>

            {open.show === false && <button className = "btns" onClick={handleClick2}> Suggestions </button>}
            {open.show === false && <button className = "btns" onClick={handleClick3}> Custom Input </button>}

            {open.show === true &&

                <div onClick={handleImage}>
                    <p> {menuSelected}</p>
                    <img src={image} alt="" />

                </div>}


            {open.open && open.show === false ?


                <div className="container">
                    <div className="box1 box" onClick={() => dispatch({ type: 'healthy' })}>  </div>
                    <div className="box2 box" onClick={() => dispatch({ type: 'family' })}> </div>
                    <div className="box3 box" onClick={() => dispatch({ type: 'low sodium' })}> </div>
                    <div className="box4 box" onClick={() => dispatch({ type: 'low calorie' })}> </div>
                    <div className="box6 box" onClick={() => dispatch({ type: 'balanced' })}> </div>
                    <div className="box7 box" onClick={() => dispatch({ type: 'high protein' })}> </div>
                    <div className="box8 box" onClick={() => dispatch({ type: 'low carb' })}> </div>
                    <div className="box9 box" onClick={() => dispatch({ type: 'low fat' })}> </div>

                </div>


                : null
            }

            {open.custom && <div className="custom-input">

                <div className="grid-item" onChange={e => setDiet(e.target.value)}>
                    <h1> Diet Labels </h1>
                    <input type="checkbox" value="balanced" />
                    <label for="check1"> Balanced </label>
                    <input type="checkbox" value="high-fiber" />
                    <label for="check2"> High Fiber </label>
                    <input type="checkbox" value="high-protein" />
                    <label for="check2"> High Protein </label>
                    <input type="checkbox" value="low-carb" />
                    <label for="check2"> Low-Carb </label>
                    <input type="checkbox" value="low-fat" />
                    <label for="check2"> Low-Fat </label>
                    <input type="checkbox" value="low-sodium" />
                    <label for="check2"> Low-Sodium </label>

                </div>
                <div className="grid-item" onChange={e => setMeal(e.target.value)}>
                    <h1> Meal Types </h1>
                    <input type="checkbox" value="Breakfast" />
                    <label> Breakfast </label>
                    <input type="checkbox" value="Lunch" />
                    <label> Lunch </label>
                    <input type="checkbox" value="Dinner" />
                    <label> Dinner</label>
                    <input type="checkbox" value="Snack" />
                    <label> Snack </label>

                </div>
                <div className="grid-item" onChange={e => setCuisine(e.target.value)}>
                    <h1> Cuisine Types </h1>
                    <input type="checkbox" value="American" />
                    <label> American </label>
                    <input type="checkbox" value="Chinese" />
                    <label> Chinese </label>
                    <input type="checkbox" value="Asian" />
                    <label> Asian </label>
                    <input type="checkbox" value="Japanese" />
                    <label> Japanese </label>
                    <input type="checkbox" value="Central Europe" />
                    <label> European </label>
                    <input type="checkbox" value="Mexican" />
                    <label> Mexican </label>
                    <input type="checkbox" value="Middle Eastern" />
                    <label> Middle Eastern </label>

                </div>
                <div className="grid-item" onChange={e => setHealth(e.target.value)}>
                    <h1> Health labels  </h1>
                    <input type="checkbox" value="dairy-free" />
                    <label> Dairy free </label>
                    <input type="checkbox" value="alcohol-free" />
                    <label> Alcohol free </label>
                    <input type="checkbox" value="peanut-free" />
                    <label> Peanut free </label>
                    <input type="checkbox" value="vegan" />
                    <label> Vegan </label>
                    <input type="checkbox" value="soy-free" />
                    <label> Soy free  </label>
                    <input type="checkbox" value="pork-free" />
                    <label> Pork free  </label>

                </div>
                <div className="grid-item" onChange={e => setDish(e.target.value)}>
                    <h1> Dish Types </h1>
                    <input type="checkbox" value="Main course" />
                    <label> Main course </label>
                    <input type="checkbox" value="Starter" />
                    <label> Appetizer </label>
                    <input type="checkbox" value="Desserts" />
                    <label> Dessert </label>

                </div>
            </div>}

            {open.show ? <Video link={open.video} /> : null}

            {open.show ? <div className="btn-div">
                    <button className = "btns" onClick={() => setOpens(!opens)}> Resources </button>

                </div> : null}

                {opens && <Modal open={[opens, setOpens]} foodData={[blog, ingr]} />}
        </div>



    )
}




function Video(props) {
    const URL = `https://www.youtube.com/watch?v=${props.link}`
    return (
        <>
            <ReactPlayer
                url={URL}
                controls={true}

            />
        </>
    )
}







export default FoodSearch
